// extracted by mini-css-extract-plugin
export default {"reviews":"product-rating__reviews___26OFf","star-rating":"product-rating__star-rating___1U5kN"};